import { render, staticRenderFns } from "./AccountDashboard.html?vue&type=template&id=d16f588e&scoped=true&"
import script from "./AccountDashboard.ts?vue&type=script&lang=ts&"
export * from "./AccountDashboard.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_dashboard.scss?vue&type=style&index=0&id=d16f588e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16f588e",
  null
  
)

export default component.exports